import { createStore as defaultCreateStore, compose as defaultCompose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { routerMiddleware } from 'connected-react-router';

import { composeWithDevTools } from 'redux-devtools-extension';
// import logger from 'redux-logger';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import history from './history';

declare const module: NodeModule;
interface NodeModule {
  hot: {
    accept: (root: string, fn: () => void) => void;
  };
}

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = composeWithDevTools({});
  const mids = applyMiddleware(routerMiddleware(history), sagaMiddleware);

  const compose = process.env.NODE_ENV !== 'production' ? composeEnhancers : defaultCompose;

  const store = defaultCreateStore(rootReducer(history), compose(mids));

  sagaMiddleware.run(rootSaga);

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./rootReducer', () => {
        const nextReducers = rootReducer;
        store.replaceReducer(nextReducers(history));
      });
    }
  }

  return store;
};

export default createStore;

const rootReducerValue = rootReducer(history);
export type RootState = ReturnType<typeof rootReducerValue>;
